import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import toTrackingSlug from '@/utils/functions/tracking/toTrackingSlug/toTrackingSlug';

interface HandleNotificationLinkClickParams {
  title: string;
  link: string;
  openInNewTab?: boolean | null;
}

const handleNotificationLinkClick = ({ title, link, openInNewTab }: HandleNotificationLinkClickParams): void => {
  void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
    event_id: 'clic',
    event_categorie: 'clic',
    event_metier: 'espace client placement',
    event_nom: toTrackingSlug(title),
    event_detail_1: 'notifications',
  });

  globalThis.open(link, openInNewTab ? '_blank' : '_self');
};

export default handleNotificationLinkClick;
